<template>
  <div class="mb-2 flex justify-center">
    <LinkToCreateEdit :to="{ name: 'serviceCreate' }">
      Add Service
    </LinkToCreateEdit>
  </div>

  <div class="mb-4">
    <SearchInput v-model="searchRaw" />
  </div>

  <BaseInnerLoading v-if="isLoading" />

  <ul
    v-else-if="services"
    class="divide-y divide-background-fg/8"
  >
    <template v-for="service in services" :key="service.id">
      <li>
        <RouterLink
          :to="{
            name: 'serviceEdit',
            params: {
              serviceId: service.id,
            },
          }"
        >
          <div
            class="flex items-center justify-between space-x-2 p-2"
          >
            <div>
              <div
                class="text-lg font-semibold text-background-fg/87"
              >
                {{ service.name }}
              </div>
              <div class="text-sm text-background-fg/70">
                {{ service.description }}
              </div>
            </div>
            <div class="text-center text-lg">
              {{
                service.cost
                  ? formatToCurrencyString(service.cost)
                  : "Configurable"
              }}
            </div>
          </div>
        </RouterLink>
      </li>
    </template>
  </ul>
</template>

<script setup lang="ts">
const searchRaw = ref<string>("")
const search = refDebounced(searchRaw, 750)

const query = reactiveComputed(() => ({
  search: search.value?.trim(),
}))

const { data: services, isLoading } = useServices(query)
</script>
